import { defineComponent as _defineComponent } from 'vue'
import type { Package } from '@/@types/graphql-types';

import { computed } from 'vue';
import { useConstantStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderIcon',
  props: {
    providerId: { default: 1 },
    providerShortName: null,
    lazy: { type: Boolean, default: true },
    size: { default: 'icon' },
    iconUrl: { default: null },
    forceWide: { type: Boolean, default: false },
    forceAvif: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { providerId: number, providerShortName?: string, lazy: boolean, size: 'icon' | 'small', iconUrl: string | null, forceWide: boolean, forceAvif: boolean };

const PROVIDER_FALLBACK_NAME = 'JustWatch';
const FALLBACK_ICON = 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png';

const profiles = {
	icon: 's100',
	small: 's40',
} as const;



const { allProvidersById, allProvidersByShortName } = useConstantStore();

const provider = computed<Package | undefined>(() => {
	if (props.providerShortName != null) return allProvidersByShortName.value[props.providerShortName];
	else if (props.providerId != null) return allProvidersById.value[props.providerId];
	return undefined;
});

const providerClearName = computed(() => provider.value?.clearName ?? PROVIDER_FALLBACK_NAME);

const iconUrlRaw = computed(() => {
	let icon = props.iconUrl ?? provider.value?.icon;

	if (!icon) return FALLBACK_ICON;

	if (icon.startsWith('/')) {
		icon = `${JW_CONFIG.IMAGESCALER_URL}${icon.replace('{profile}', profiles[props.size])}`;
	}

	return icon;
});

const isWideIcon = computed(() => props.forceWide || iconUrlRaw.value.includes('icon_wide'));

// in case the campaign icon override is PNG we don't render the webp and avif sources for transparency
const isPng = computed(() => iconUrlRaw.value.endsWith('.png'));

const imageUrl = computed(() => iconUrlRaw.value.replace('{format}', 'jpeg'));

const webpImageUrl = computed(() => iconUrlRaw.value.replace('{format}', 'webp'));
const avifImageUrl = computed(() => {
	if (props.forceAvif && !iconUrlRaw.value.includes('{format}')) {
		return iconUrlRaw.value.replace(/\.\w+$/, '.avif');
	}
	return iconUrlRaw.value.replace('{format}', 'avif');
});

return { __sfc: true,PROVIDER_FALLBACK_NAME, FALLBACK_ICON, profiles, props, allProvidersById, allProvidersByShortName, provider, providerClearName, iconUrlRaw, isWideIcon, isPng, imageUrl, webpImageUrl, avifImageUrl }
}

})